<template>
    <ValidationProvider :name="name" :rules="field._validation" v-slot="validator">
        <b-field>
            <EvoLabel slot="label" :name="name" :field="field" :validator="validator"></EvoLabel>
            <b-input v-model="value" type="textarea" :name="name" :id="name" :custom-class="validator.failed ? 'input_error' : ''"
            :placeholder="field._placeholder"></b-input>
        </b-field>
        <EvoError v-if="validator.errors[0]" :validator="validator"></EvoError>
    </ValidationProvider>
</template>

<script>
import mixin from "./mixin";

export default {
    mixins: [mixin],
}
</script>
